import { defaultOption } from 'shared/form/select/option-helpers';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';


/* eslint-disable */

const createCreditCardYearLookup = (): any[] => {
  const year = Number(moment().format('YY'));

  if (_.isNumber(year)) {
    return Array.from(new Array(Number(21)), (val, index)=> {
      let optionYear = `${index + year}`;
      if (optionYear.length === 1) optionYear = `0${optionYear}`;
      return {'option' : optionYear, 'title' : optionYear};
    });
  }

  return [];
};

export const countryLookup = [
  { 'option': '', 'title': '-' },
  { "option": "AF", "title": "Afghanistan" }, { "option": "AX", "title": "Aland Islands" }, { "option": "AL", "title": "Albania" },
  { "option": "DZ", "title": "Algeria" }, { "option": "AS", "title": "American Samoa" }, { "option": "AD", "title": "Andorra" },
  { "option": "AO", "title": "Angola" }, { "option": "AI", "title": "Anguilla" }, { "option": "AQ", "title": "Antarctica" },
  { "option": "AG", "title": "Antigua and Barbuda" }, { "option": "AR", "title": "Argentina" }, { "option": "AM", "title": "Armenia" },
  { "option": "AW", "title": "Aruba" }, { "option": "AU", "title": "Australia" }, { "option": "AT", "title": "Austria" },
  { "option": "AZ", "title": "Azerbaijan" }, { "option": "BS", "title": "Bahamas" }, { "option": "BH", "title": "Bahrain" },
  { "option": "BD", "title": "Bangladesh" }, { "option": "BB", "title": "Barbados" }, { "option": "BY", "title": "Belarus" },
  { "option": "BE", "title": "Belgium" }, { "option": "BZ", "title": "Belize" }, { "option": "BJ", "title": "Benin" },
  { "option": "BM", "title": "Bermuda" }, { "option": "BT", "title": "Bhutan" }, { "option": "BO", "title": "Bolivia" },
  { "option": "BA", "title": "Bosnia and Herzegovina" }, { "option": "BW", "title": "Botswana" }, { "option": "BV", "title": "Bouvet Island" },
  { "option": "BR", "title": "Brazil" }, { "option": "VG", "title": "British Virgin Islands" }, { "option": "IO", "title": "British Indian Ocean Territory" },
  { "option": "BN", "title": "Brunei Darussalam" }, { "option": "BG", "title": "Bulgaria" }, { "option": "BF", "title": "Burkina Faso" },
  { "option": "BI", "title": "Burundi" }, { "option": "KH", "title": "Cambodia" }, { "option": "CM", "title": "Cameroon" },
  { "option": "CA", "title": "Canada" }, { "option": "CV", "title": "Cape Verde" }, { "option": "KY", "title": "Cayman Islands" },
  { "option": "CF", "title": "Central African Republic" }, { "option": "TD", "title": "Chad" }, { "option": "CL", "title": "Chile" },
  { "option": "CN", "title": "China" }, { "option": "HK", "title": "Hong Kong, SAR China" }, { "option": "MO", "title": "Macao, SAR China" },
  { "option": "CX", "title": "Christmas Island" }, { "option": "CC", "title": "Cocos (Keeling) Islands" }, { "option": "CO", "title": "Colombia" },
  { "option": "KM", "title": "Comoros" }, { "option": "CG", "title": "Congo (Brazzaville)" }, { "option": "CD", "title": "Congo, (Kinshasa)" },
  { "option": "CK", "title": "Cook Islands" }, { "option": "CR", "title": "Costa Rica" }, { "option": "CI", "title": "Côte d'Ivoire" },
  { "option": "HR", "title": "Croatia" }, { "option": "CU", "title": "Cuba" }, { "option": "CY", "title": "Cyprus" },
  { "option": "CZ", "title": "Czech Republic" }, { "option": "DK", "title": "Denmark" }, { "option": "DJ", "title": "Djibouti" },
  { "option": "DM", "title": "Dominica" }, { "option": "DO", "title": "Dominican Republic" }, { "option": "EC", "title": "Ecuador" },
  { "option": "EG", "title": "Egypt" }, { "option": "SV", "title": "El Salvador" }, { "option": "GQ", "title": "Equatorial Guinea" },
  { "option": "ER", "title": "Eritrea" }, { "option": "EE", "title": "Estonia" }, { "option": "ET", "title": "Ethiopia" },
  { "option": "FK", "title": "Falkland Islands (Malvinas)" }, { "option": "FO", "title": "Faroe Islands" }, { "option": "FJ", "title": "Fiji" },
  { "option": "FI", "title": "Finland" }, { "option": "FR", "title": "France" }, { "option": "GF", "title": "French Guiana" },
  { "option": "PF", "title": "French Polynesia" }, { "option": "TF", "title": "French Southern Territories" }, { "option": "GA", "title": "Gabon" },
  { "option": "GM", "title": "Gambia" }, { "option": "GE", "title": "Georgia" }, { "option": "DE", "title": "Germany" },
  { "option": "GH", "title": "Ghana" }, { "option": "GI", "title": "Gibraltar" }, { "option": "GR", "title": "Greece" },
  { "option": "GL", "title": "Greenland" }, { "option": "GD", "title": "Grenada" }, { "option": "GP", "title": "Guadeloupe" },
  { "option": "GU", "title": "Guam" }, { "option": "GT", "title": "Guatemala" }, { "option": "GG", "title": "Guernsey" },
  { "option": "GN", "title": "Guinea" }, { "option": "GW", "title": "Guinea-Bissau" }, { "option": "GY", "title": "Guyana" },
  { "option": "HT", "title": "Haiti" }, { "option": "HM", "title": "Heard and Mcdonald Islands" }, { "option": "VA", "title": "Holy See (Vatican City State)" },
  { "option": "HN", "title": "Honduras" }, { "option": "HU", "title": "Hungary" }, { "option": "IS", "title": "Iceland" },
  { "option": "IN", "title": "India" }, { "option": "ID", "title": "Indonesia" }, { "option": "IR", "title": "Iran, Islamic Republic of" },
  { "option": "IQ", "title": "Iraq" }, { "option": "IE", "title": "Ireland" }, { "option": "IM", "title": "Isle of Man" },
  { "option": "IL", "title": "Israel" }, { "option": "IT", "title": "Italy" }, { "option": "JM", "title": "Jamaica" },
  { "option": "JP", "title": "Japan" }, { "option": "JE", "title": "Jersey" }, { "option": "JO", "title": "Jordan" },
  { "option": "KZ", "title": "Kazakhstan" }, { "option": "KE", "title": "Kenya" }, { "option": "KI", "title": "Kiribati" },
  { "option": "KP", "title": "Korea (North)" }, { "option": "KR", "title": "Korea (South)" }, { "option": "KW", "title": "Kuwait" },
  { "option": "KG", "title": "Kyrgyzstan" }, { "option": "LA", "title": "Lao PDR" }, { "option": "LV", "title": "Latvia" },
  { "option": "LB", "title": "Lebanon" }, { "option": "LS", "title": "Lesotho" }, { "option": "LR", "title": "Liberia" },
  { "option": "LY", "title": "Libya" }, { "option": "LI", "title": "Liechtenstein" }, { "option": "LT", "title": "Lithuania" },
  { "option": "LU", "title": "Luxembourg" }, { "option": "MK", "title": "Macedonia, Republic of" }, { "option": "MG", "title": "Madagascar" },
  { "option": "MW", "title": "Malawi" }, { "option": "MY", "title": "Malaysia" }, { "option": "MV", "title": "Maldives" },
  { "option": "ML", "title": "Mali" }, { "option": "MT", "title": "Malta" }, { "option": "MH", "title": "Marshall Islands" },
  { "option": "MQ", "title": "Martinique" }, { "option": "MR", "title": "Mauritania" }, { "option": "MU", "title": "Mauritius" },
  { "option": "YT", "title": "Mayotte" }, { "option": "MX", "title": "Mexico" }, { "option": "FM", "title": "Micronesia, Federated States of" },
  { "option": "MD", "title": "Moldova" }, { "option": "MC", "title": "Monaco" }, { "option": "MN", "title": "Mongolia" },
  { "option": "ME", "title": "Montenegro" }, { "option": "MS", "title": "Montserrat" }, { "option": "MA", "title": "Morocco" },
  { "option": "MZ", "title": "Mozambique" }, { "option": "MM", "title": "Myanmar" }, { "option": "NA", "title": "Namibia" },
  { "option": "NR", "title": "Nauru" }, { "option": "NP", "title": "Nepal" }, { "option": "NL", "title": "Netherlands" },
  { "option": "AN", "title": "Netherlands Antilles" }, { "option": "NC", "title": "New Caledonia" }, { "option": "NZ", "title": "New Zealand" },
  { "option": "NI", "title": "Nicaragua" }, { "option": "NE", "title": "Niger" }, { "option": "NG", "title": "Nigeria" },
  { "option": "NU", "title": "Niue" }, { "option": "NF", "title": "Norfolk Island" }, { "option": "MP", "title": "Northern Mariana Islands" },
  { "option": "NO", "title": "Norway" }, { "option": "OM", "title": "Oman" }, { "option": "PK", "title": "Pakistan" },
  { "option": "PW", "title": "Palau" }, { "option": "PS", "title": "Palestinian Territory" }, { "option": "PA", "title": "Panama" },
  { "option": "PG", "title": "Papua New Guinea" }, { "option": "PY", "title": "Paraguay" }, { "option": "PE", "title": "Peru" },
  { "option": "PH", "title": "Philippines" }, { "option": "PN", "title": "Pitcairn" }, { "option": "PL", "title": "Poland" },
  { "option": "PT", "title": "Portugal" }, { "option": "PR", "title": "Puerto Rico" }, { "option": "QA", "title": "Qatar" },
  { "option": "RE", "title": "Réunion" }, { "option": "RO", "title": "Romania" }, { "option": "RU", "title": "Russian Federation" },
  { "option": "RW", "title": "Rwanda" }, { "option": "BL", "title": "Saint-Barthélemy" }, { "option": "SH", "title": "Saint Helena" },
  { "option": "KN", "title": "Saint Kitts and Nevis" }, { "option": "LC", "title": "Saint Lucia" }, { "option": "MF", "title": "Saint-Martin (French part)" },
  { "option": "PM", "title": "Saint Pierre and Miquelon" }, { "option": "VC", "title": "Saint Vincent and Grenadines" }, { "option": "WS", "title": "Samoa" },
  { "option": "SM", "title": "San Marino" }, { "option": "ST", "title": "Sao Tome and Principe" }, { "option": "SA", "title": "Saudi Arabia" },
  { "option": "SN", "title": "Senegal" }, { "option": "RS", "title": "Serbia" }, { "option": "SC", "title": "Seychelles" },
  { "option": "SL", "title": "Sierra Leone" }, { "option": "SG", "title": "Singapore" }, { "option": "SK", "title": "Slovakia" },
  { "option": "SI", "title": "Slovenia" }, { "option": "SB", "title": "Solomon Islands" }, { "option": "SO", "title": "Somalia" },
  { "option": "ZA", "title": "South Africa" }, { "option": "GS", "title": "South Georgia and the South Sandwich Islands" }, { "option": "SS", "title": "South Sudan" },
  { "option": "ES", "title": "Spain" }, { "option": "LK", "title": "Sri Lanka" }, { "option": "SD", "title": "Sudan" },
  { "option": "SR", "title": "Suriname" }, { "option": "SJ", "title": "Svalbard and Jan Mayen Islands" }, { "option": "SZ", "title": "Swaziland" },
  { "option": "SE", "title": "Sweden" }, { "option": "CH", "title": "Switzerland" }, { "option": "SY", "title": "Syrian Arab Republic (Syria)" },
  { "option": "TW", "title": "Taiwan, Republic of China" }, { "option": "TJ", "title": "Tajikistan" }, { "option": "TZ", "title": "Tanzania, United Republic of" },
  { "option": "TH", "title": "Thailand" }, { "option": "TL", "title": "Timor-Leste" }, { "option": "TG", "title": "Togo" },
  { "option": "TK", "title": "Tokelau" }, { "option": "TO", "title": "Tonga" }, { "option": "TT", "title": "Trinidad and Tobago" },
  { "option": "TN", "title": "Tunisia" }, { "option": "TR", "title": "Turkey" }, { "option": "TM", "title": "Turkmenistan" },
  { "option": "TC", "title": "Turks and Caicos Islands" }, { "option": "TV", "title": "Tuvalu" }, { "option": "UG", "title": "Uganda" },
  { "option": "UA", "title": "Ukraine" }, { "option": "AE", "title": "United Arab Emirates" }, { "option": "GB", "title": "United Kingdom" },
  { "option": "US", "title": "United States of America" }, { "option": "UM", "title": "US Minor Outlying Islands" }, { "option": "UY", "title": "Uruguay" },
  { "option": "UZ", "title": "Uzbekistan" }, { "option": "VU", "title": "Vanuatu" }, { "option": "VE", "title": "Venezuela (Bolivarian Republic)" },
  { "option": "VN", "title": "Viet Nam" }, { "option": "VI", "title": "Virgin Islands, US" }, { "option": "WF", "title": "Wallis and Futuna Islands" },
  { "option": "EH", "title": "Western Sahara" }, { "option": "YE", "title": "Yemen" }, { "option": "ZM", "title": "Zambia" },
  { "option": "ZW", "title": "Zimbabwe" }
];

export const partCategoryLookup = [
  {'option': defaultOption.option, 'title': 'Product category'},
  {'option': 'BR1', 'title': 'Brake 1'},
  {'option': 'BR2', 'title': 'Brake 2'},
];

export const partSubCategoryLookup = [
  {'option': defaultOption.option, 'title': 'Product sub-category'},
  {'option': 'BR3', 'title': 'Brake 3'},
  {'option': 'BR4', 'title': 'Brake 4'},
];

// marketing
export const marketingCodeLookup = [
  {'option': 'BRD', 'title': 'Brand'},
  {'option': 'BOW', 'title': 'Brand Owner'},
  {'option': 'BPR', 'title': 'Parent Company'},
  {'option': 'SBR', 'title': 'Sub-Brand'},
  {'option': 'PTI', 'title': 'Part Type'},
  {'option': 'PGC', 'title': 'Product Group'},
  {'option': 'PSG', 'title': 'Product Sub-Group'},
  {'option': 'PCC', 'title': 'AAIA Product Category Code'},
];

export const marketingTypeLookup = [
  {'option' : 'FAB', 'title' : 'Features and Benefits'},
  {'option' : 'GCC', 'title' : 'General Copy'},
];

export const monthLookup = [
  {'option' : '01', 'title' : '01'},
  {'option' : '02', 'title' : '02'},
  {'option' : '03', 'title' : '03'},
  {'option' : '04', 'title' : '04'},
  {'option' : '05', 'title' : '05'},
  {'option' : '06', 'title' : '06'},
  {'option' : '07', 'title' : '07'},
  {'option' : '08', 'title' : '08'},
  {'option' : '09', 'title' : '09'},
  {'option' : '10', 'title' : '10'},
  {'option' : '11', 'title' : '11'},
  {'option' : '12', 'title' : '12'},
];

export const creditCardYearLookup = createCreditCardYearLookup();

export const usStateLookup = [
  {'option' : 'AL', 'title' : 'Alabama'},
  {'option' : 'AK', 'title' : 'Alaska'},
  {'option' : 'AZ', 'title' : 'Arizona'},
  {'option' : 'AR', 'title' : 'Arkansas'},
  {'option' : 'CA', 'title' : 'California'},
  {'option' : 'CO', 'title' : 'Colorado'},
  {'option' : 'CT', 'title' : 'Connecticut'},
  {'option' : 'DE', 'title' : 'Delaware'},
  {'option' : 'FL', 'title' : 'Florida'},
  {'option' : 'GA', 'title' : 'Georgia'},
  {'option' : 'HI', 'title' : 'Hawaii'},
  {'option' : 'ID', 'title' : 'Idaho'},
  {'option' : 'IL', 'title' : 'Illinois'},
  {'option' : 'IN', 'title' : 'Indiana'},
  {'option' : 'IA', 'title' : 'Iowa'},
  {'option' : 'KS', 'title' : 'Kansas'},
  {'option' : 'KY', 'title' : 'Kentucky'},
  {'option' : 'LA', 'title' : 'Louisiana'},
  {'option' : 'ME', 'title' : 'Maine'},
  {'option' : 'MD', 'title' : 'Maryland'},
  {'option' : 'MA', 'title' : 'Massachusetts'},
  {'option' : 'MI', 'title' : 'Michigan'},
  {'option' : 'MN', 'title' : 'Minnesota'},
  {'option' : 'MS', 'title' : 'Mississippi'},
  {'option' : 'MO', 'title' : 'Missouri'},
  {'option' : 'MT', 'title' : 'Montana'},
  {'option' : 'NE', 'title' : 'Nebraska'},
  {'option' : 'NV', 'title' : 'Nevada'},
  {'option' : 'NH', 'title' : 'New Hampshire'},
  {'option' : 'NJ', 'title' : 'New Jersey'},
  {'option' : 'NM', 'title' : 'New Mexico'},
  {'option' : 'NY', 'title' : 'New York'},
  {'option' : 'NC', 'title' : 'North Carolina'},
  {'option' : 'ND', 'title' : 'North Dakota'},
  {'option' : 'OH', 'title' : 'Ohio'},
  {'option' : 'OK', 'title' : 'Oklahoma'},
  {'option' : 'OR', 'title' : 'Oregon'},
  {'option' : 'PA', 'title' : 'Pennsylvania'},
  {'option' : 'RI', 'title' : 'Rhode Island'},
  {'option' : 'SC', 'title' : 'South Carolina'},
  {'option' : 'SD', 'title' : 'South Dakota'},
  {'option' : 'TN', 'title' : 'Tennessee'},
  {'option' : 'TX', 'title' : 'Texas'},
  {'option' : 'UT', 'title' : 'Utah'},
  {'option' : 'VT', 'title' : 'Vermont'},
  {'option' : 'VA', 'title' : 'Virginia'},
  {'option' : 'WA', 'title' : 'Washington'},
  {'option' : 'WV', 'title' : 'West Virginia'},
  {'option' : 'WI', 'title' : 'Wisconsin'},
  {'option' : 'WY', 'title' : 'Wyoming'},
  {'option' : 'GU', 'title' : 'Guam'},
  {'option' : 'PR', 'title' : 'Puerto Rico'},
  {'option' : 'VI', 'title' : 'Virgin Islands'},
];

export const mxStateLookup = [
  { "option": "AG", "title": "Aguascalientes" },
  { "option": "BN", "title": "Baja California" },
  { "option": "BS", "title": "Baja California Sur" },
  { "option": "CM", "title": "Campeche" },
  { "option": "CP", "title": "Chiapas" },
  { "option": "CH", "title": "Chihuahua" },
  { "option": "CU", "title": "Coahuila" },
  { "option": "CL", "title": "Colima" },
  { "option": "CX", "title": "Mexico City" },
  { "option": "DU", "title": "Durango" },
  { "option": "GJ", "title": "Guanajuato" },
  { "option": "GR", "title": "Guerrero" },
  { "option": "HI", "title": "Hidalgo" },
  { "option": "JA", "title": "Jalisco" },
  { "option": "MX", "title": "México" },
  { "option": "MC", "title": "Michoacán" },
  { "option": "MR", "title": "Morelos" },
  { "option": "NA", "title": "Nayarit" },
  { "option": "NL", "title": "Nuevo León" },
  { "option": "OA", "title": "Oaxaca" },
  { "option": "PU", "title": "Puebla" },
  { "option": "QE", "title": "Querétaro" },
  { "option": "QR", "title": "Quintana Roo" },
  { "option": "SL", "title": "San Luis Potosí" },
  { "option": "SI", "title": "Sinaloa" },
  { "option": "SO", "title": "Sonora" },
  { "option": "TB", "title": "Tabasco" },
  { "option": "TM", "title": "Tamaulipas" },
  { "option": "TL", "title": "Tlaxcala" },
  { "option": "VE", "title": "Veracruz" },
  { "option": "YU", "title": "Yucatán" },
  { "option": "ZA", "title": "Zacatecas" },
];

export const caStateLookup = [
  { "option": "AB", "title": "Alberta" },
  { "option": "BC", "title": "Colombie-Britannique" },
  { "option": "MB", "title": "Manitoba" },
  { "option": "NB", "title": "Nouveau-Brunswick" },
  { "option": "NL", "title": "Terre-Neuve-et-Labrador" },
  { "option": "NS", "title": "Nouvelle-Écosse" },
  { "option": "ON", "title": "Ontario" },
  { "option": "PE", "title": "Île-du-Prince-Édouard" },
  { "option": "QC", "title": "Québec" },
  { "option": "SK", "title": "Saskatchewan" },
  { "option": "NT", "title": "Territoires du Nord-Ouest" },
  { "option": "NU", "title": "Nunavut" },
  { "option": "YT", "title": "Yukon" },
];

const getTimezoneLookup = (): Array<any> => {
  const names = moment.tz.names();
  const timezones:Array<any> = [];
  const currDate = new Date();
  _.forEach(names, (name: string) => {
    const zone = moment.tz.zone(name);
    const gmtOffsetBig = moment.tz(currDate, name).format('ZZ');
    const gmtOffsetSmall = moment.tz(currDate, name).format('Z');

    // don't include Etc/... and GMT-... named timezones
    if (name.indexOf('Etc') < 0 && name.indexOf('GMT') < 0) {
      timezones.push({
        'option': name,
        'title': (`(GMT${gmtOffsetSmall}) ${name}`).replace(/_/g, ' '),
        'gmtOffset': Number(gmtOffsetBig),
      });
    }
  });

  // sort by offset
  let sortedTZ = _.sortBy(timezones, 'gmtOffset');

  // set the order:
  // (GMT-05:00) - US/Eastern
  // (GMT-06:00) - US/Central
  // (GMT-08:00) - US/Pacific
  // other sorted
  // @ts-ignore
    const eastern = _.find(sortedTZ, {'option': 'US/Eastern'});
  // @ts-ignore
    const central = _.find(sortedTZ, {'option': 'US/Central'});
  // @ts-ignore
    const pacific = _.find(sortedTZ, {'option': 'US/Pacific'});
  _.pullAllBy(sortedTZ, [pacific, central, eastern], 'option');
  sortedTZ = [eastern, central, pacific, ...sortedTZ];

  return sortedTZ;
};

export const timezoneLookup = getTimezoneLookup();

export const yesNoLookup:any = [
  {
    'option': '',
    'title': '-',
  },
  {
    'option': 'N',
    'title': 'No',
  },
  {
    'option': 'Y',
    'title': 'Yes',
  }
];

/* eslint-enable */
